// extracted by mini-css-extract-plugin
export default {"title":"AssignTaskPopup_title__ip-LS","action":"AssignTaskPopup_action__BbwhT"};